/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 12:39:21
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-24 15:11:06
 * @FilePath: /unifyxp-v2-store-portal/src/components/EditableTable/EditableTable.tsx
 */
import React from 'react';
import css from './css.less';
import Table from '@/src/components/Antd/Table/SizeFittingTable';
import { EditOutlined, CloseOutlined } from '@ant-design/icons';
import AddNew from 'src/components/GreenAddBtn/GreenAddBtn';
const CustomTable = (props) => {
  const {
    data,
    columns,
    onRowClick,
    // onBlur = () => {},
    id,
    addText,
    addFun,
    rowDeleteFunc,
    className,
    disableAdd,
    pagination,
    disabled,
    ...rest
  } = props;

  const deleteCol = React.useMemo(() => {
    if (rowDeleteFunc) {
      return [
        ...columns,
        {
          title: '',
          default: true,
          key: 'action',
          render: (text, record, index) => (
            <div
              className={css.deleteContainer}
              onClick={() => {
                rowDeleteFunc(index, record);
              }}>
              {!disabled && <CloseOutlined />}
            </div>
          ),
          width: 64,
        },
      ];
    } else {
      return columns;
    }
  }, [columns, rowDeleteFunc]);

  return (
    <React.Fragment>
      <div className={css.container}>
        <Table
          id={id}
          className={className}
          dataSource={data}
          columns={deleteCol}
          onRow={(record, index) => {
            return {
              onClick: (event) => {
                if (onRowClick) onRowClick(index);
              }, // 点击行
            };
          }}
          pagination={pagination || false}
          {...rest}
        />
      </div>
      {addFun && (
        <AddNew addFun={addFun} addText={addText} disable={disableAdd} />
      )}
    </React.Fragment>
  );
};
export default CustomTable;
const EditIcon = (props) => {
  return <EditOutlined className={css.icon} />;
};
const BackTitle = (props) => {
  const { children } = props;
  return <div className={css.backHeader}>{children}</div>;
};
const FrontTitle = (props) => {
  const { children } = props;
  return <div className={css.frontHeader}>{children}</div>;
};
const MidTitle = (props) => {
  const { children } = props;
  return <div className={css.midHeader}>{children}</div>;
};
const FirstTitle = (props) => {
  const { children } = props;
  return <div className={css.firstHeader}>{children}</div>;
};

export { EditIcon, BackTitle, FrontTitle, FirstTitle, MidTitle };
